// Formatos iguais aos do protótipo.
export const TZ = 'America/Sao_Paulo';

export function money(c: number): string {
  return 'R$ ' + (c / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
export function moneyShort(c: number): string {
  return 'R$ ' + Math.round(c / 100).toLocaleString('pt-BR');
}
export function parseMoney(s: string): number {
  const t = String(s ?? '').replace(/[^\d,.]/g, '');
  if (!t) return NaN;
  const v = parseFloat(t.includes(',') ? t.replace(/\./g, '').replace(',', '.') : t);
  return Number.isNaN(v) ? NaN : Math.round(v * 100);
}
export const hhmm = (m: number) => `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
export const toMin = (s: string) => { const [h, m] = s.split(':').map(Number); return (h ?? 0) * 60 + (m ?? 0); };
export const dur = (m: number) => (m >= 60 ? `${Math.floor(m / 60)}h${m % 60 ? String(m % 60).padStart(2, '0') : ''}` : `${m} min`);
export const durLabel = (m: number) => (m >= 60 ? `${Math.floor(m / 60)}h${m % 60 ? ` e ${m % 60} min` : ''}` : `${m} min`);
export const first = (name: string) => name.split(' ')[0] ?? name;
export const initials = (n: string) => n.split(' ').filter(Boolean).map((w) => w[0]).slice(0, 2).join('').toUpperCase();

// cor do avatar estável por pessoa (rose · ink · taupe, como no protótipo)
const TONES = ['rose', 'ink', 'taupe'] as const;
export function tone(id: string): (typeof TONES)[number] {
  let h = 0;
  for (const ch of id) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return TONES[h % 3]!;
}

// data e hora no fuso do salão
export function nowLocal(): { date: string; min: number } {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).formatToParts(new Date());
  const g = (t: string) => parts.find((p) => p.type === t)?.value ?? '';
  return { date: `${g('year')}-${g('month')}-${g('day')}`, min: Number(g('hour')) * 60 + Number(g('minute')) };
}
export function isoLocal(iso: string | Date): { date: string; time: string; min: number } {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).formatToParts(d);
  const g = (t: string) => parts.find((p) => p.type === t)?.value ?? '';
  const time = `${g('hour')}:${g('minute')}`;
  return { date: `${g('year')}-${g('month')}-${g('day')}`, time, min: toMin(time) };
}
export function addDays(date: string, n: number): string {
  const d = new Date(`${date}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}
export const dowIndex = (date: string) => new Date(`${date}T12:00:00Z`).getUTCDay();
export const DOW_SHORT = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
export const DOW_LONG = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
export const MONTHS = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
export const ddmm = (date: string) => `${date.slice(8, 10)}/${date.slice(5, 7)}`;
export const longDate = (date: string) => `${DOW_LONG[dowIndex(date)]}, ${Number(date.slice(8, 10))} de ${MONTHS[Number(date.slice(5, 7)) - 1]}`;
export function dayLabel(date: string, today: string): string {
  if (date === today) return 'hoje';
  if (date === addDays(today, 1)) return 'amanhã';
  return `${DOW_LONG[dowIndex(date)]!.toLowerCase()}, ${ddmm(date)}`;
}
export function greeting(min: number): string {
  return min < 12 * 60 ? 'Bom dia' : min < 18 * 60 ? 'Boa tarde' : 'Boa noite';
}
export function agoLabel(days: number): string {
  return days === 0 ? 'hoje' : days < 7 ? `há ${days} ${days > 1 ? 'dias' : 'dia'}` : days < 60 ? `há ${Math.round(days / 7)} sem.` : `há ${Math.round(days / 30)} meses`;
}
export function phoneDigits(s: string): string {
  const d = s.replace(/\D/g, '');
  return d.startsWith('55') && d.length > 11 ? d.slice(2) : d;
}
export function waLink(phone: string, text: string): string {
  return `https://wa.me/55${phoneDigits(phone)}?text=${encodeURIComponent(text)}`;
}
